import { render, staticRenderFns } from "./DlvPSJ_Client.vue?vue&type=template&id=94418cd0"
import script from "./DlvPSJ_Client.vue?vue&type=script&lang=js"
export * from "./DlvPSJ_Client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports